import { Customer, CustomerStatus } from '@trnsact/trnsact-shared-types';
import { CustomerTableRow } from '../types';

export const formatCustomersToTableData = (customers: Customer[]): CustomerTableRow[] => {
  return customers.map(customer => ({
    id: customer.accountId,
    accountId: customer.accountId,
    name: customer.name ?? '',
    contactName: customer.contactName ?? '',
    phone: customer.phone ?? '',
    type: customer.type ?? '',
    lastContactDate: customer.lastContactDate ?? '',
    status: customer.status ?? CustomerStatus.Active,
    totalRevenueAmount: customer.totalRevenueAmount,
    activeDealsNumber: customer.activeDealsNumber,
    opportunitiesNumber: customer.opportunitiesNumber,
  }));
};
